// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2CT0V","colMin":"styles_colMin__Mm1Ty","colCheckbox":"styles_colCheckbox__2Tna7"};